module.exports = __webpack_public_path__ + "static/media/micmute.71c818c4.svg";